<div class="flex flex-col h-full w-full justify-start items-start bg-[#FFF]">
  <app-quality-stepper [isCheckView]="true"
                       [nextStepAllowed]="(canCheckQuality && selectedFiles.length > 0) ?? false"
                       [selectedStep]="1" class="w-full"></app-quality-stepper>

  <div class="flex flex-col h-full w-full justify-start items-start gap-6 p-6 overflow-hidden">

    @if (loading) {
      <div class="flex flex-col flex-1 min-h-0 w-full justify-center items-center py-16">
        <div class="flex flex-row items-center gap-2">
          <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
          <span class="text-sm font-medium text-gray-500">Dateien werden geladen...</span>
        </div>
      </div>
    } @else {
      <app-files
        [(selectedFiles)]="selectedFiles"
        [backButtonActivated]="false"
        [calledFromCheck]="true"
        [customFilesActivated]="true"
        [customFiles]="files"
        [filterAndContextButtonActivated]="false"
        [noOuterPadding]="true"
        class="flex w-full flex-1 min-h-0">
      </app-files>
    }


    <div class="flex flex-row w-full justify-center items-center flex-shrink-0">
      <div>
        <!--button (click)="navigateToChoosingRules()"  mat-raised-button
        [disabled]="!permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE') || check || !canCheckQuality || (selectedIFCFiles.isEmpty() && selectedLVFiles.isEmpty() && selectedRBFiles.isEmpty())">
        Prüfungsauswahl
        <fa-icon [icon]="faChevronRight" class="text-white"></fa-icon>
      </button-->
        <bic-button (click)="showParameterPopUp()"
                    [tooltipDirection]="'top'" [tooltip]="!canCheckQuality! ? 'Kein Kontingent verfügbar' : undefined"
                    [disabled]="!permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE') || !!check || !canCheckQuality || selectedFiles.length == 0">
          Prüfergebnisse
          <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
        </bic-button>
        @if (showConfirmationPopup) {
          <bic-popup (close)="cancelQualityCheck()" [hasBackdrop]="true"
                     [title]="'Möchten Sie die Prüfung wirklich ausführen?'" customClass="w-[560px] h-fit">
            <div bicPopupContent class="flex flex-col gap-4 font-normal">
              <p>Bei Bestätigung der Prüfung werden die <span class="font-medium">ausgewählten Prüfregeln</span> mit den
                <span class="font-medium">ausgewählten Dateien</span> ausgeführt.</p>
              <p><span class="text-green font-medium">Hinweis: </span><br>
                Das Ausführen der Prüfung verbraucht
                <span class="font-medium">{{ checkCost }}</span>
                {{ checkCost === 1 ? 'Prüfung' : 'Prüfungen' }} Ihres Kontingents.
              </p>
              @if (!hasSufficientChecks) {
                <span>
                  Leider stehen für diese Prüfung
                  <span class="font-medium">nicht genügend Prüfungen</span>
                  zur Verfügung.
                </span>
              } @else {
                <span>
                  Nach dieser Prüfung bleiben noch <span class="font-medium">{{ checksAfterRun }}</span>
                  {{ checksAfterRun === 1 ? 'Prüfung' : 'Prüfungen' }} übrig.
                </span>
              }
            </div>
            <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
              <bic-button (onClick)="loading_check_request ? cancelQualityCheck() : showConfirmationPopup = false"
                          buttonType="white">
                Abbrechen
              </bic-button>
              <bic-button (click)="startQualityCheck()" [loading]="loading_check_request"
                          [disabled]="!permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE') || isStartQualityCheckDisabled">
                Prüfung starten
                @if (!loading_check_request) {
                  <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
                }
              </bic-button>
            </div>
          </bic-popup>
        }
      </div>
    </div>
  </div>

</div>




